/** @typedef {import('@/types/api').PosCustomerPackageBalance} PosCustomerPackageBalance */
/** @typedef {import('@/types/api').Sale} Sale */

import { countPendingFlexComboPicks } from '@/lib/pos/posFlexibleCombo'

/**
 * @param {string | null | undefined} expiresAt
 */
export function formatPackageExpiryLabel(expiresAt) {
  if (!expiresAt) return null

  const date = new Date(expiresAt)
  if (Number.isNaN(date.getTime())) return null

  const now = new Date()
  const days = Math.ceil((date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))

  if (days < 0) return 'Expired'
  if (days === 0) return 'Expires today'
  if (days <= 7) return `Expires in ${days} day(s)`

  return `Expires ${date.toLocaleDateString()}`
}

/**
 * @param {PosCustomerPackageBalance} pkg
 * @param {Sale | null | undefined} sale
 */
export function packageBalanceTicketNote(pkg, sale) {
  if (!sale || pkg.package_type !== 'flexible_combo') return null

  const pending = countPendingFlexComboPicks(sale, pkg.customer_package_id)
  if (pending <= 0) return null

  return `${pending} pick(s) on this ticket`
}

/**
 * @param {PosCustomerPackageBalance[]} packages
 */
export function countRedeemablePackageBalances(packages) {
  return packages.filter((pkg) => pkg.is_redeemable).length
}

/**
 * @param {PosCustomerPackageBalance[]} packages
 * @param {string} query
 */
export function filterPackageBalances(packages, query) {
  const needle = query.trim().toLowerCase()
  if (!needle) return packages

  return packages.filter((pkg) => {
    const haystack = [
      pkg.package_name,
      pkg.package_type,
      pkg.headline,
      ...pkg.details.map((row) => `${row.label} ${row.value}`),
    ]
      .join(' ')
      .toLowerCase()

    return haystack.includes(needle)
  })
}
